import { useState, useEffect } from "react";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";
import Select from "react-select";

import classes from "../../maintainers.module.scss";
import api from "@/services/api.service";
import { toast } from "@/services/Utils";

import Fetching from "@/components/Fetching/Fetching";
import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const EstateOut = ({ show, setShow, estate_id, setEstate }) => {
	const { addToast } = useToasts();

	const [params, setParams] = useState({
		balances: [],
		users: [],
		operators: [],
		business_centers: [],
	});
	const [data, setData] = useState({
		estate_id: estate_id,
		balance_id: "",
		user_id: "",
		operator_id: "",
		business_center_id: "",
	});
	const [isFetching, setIsFetching] = useState(false);

	useEffect(() => {
		if (show && estate_id) {
			setIsFetching(true);
			api.get(`/admin/estates/out/data`).then((response) => {
				setIsFetching(false);
				if (response) {
					setParams(response);
				}
			});
		}
	}, [show, estate_id]);

	const handleClose = () => {
		setEstate("");
		setShow(false);
	};

	const handleOut = () => {
		if (!data.user_id || !data.operator_id || !data.balance_id || !data.business_center_id) {
			toast(addToast, "Todos los campos son requeridos", "error");
			return;
		}

		setIsFetching(true);
		api.post(`/admin/estates/out_all`, { ...data, estate_id: estate_id }).then((response) => {
			setIsFetching(false);
			if (response) {
				toast(addToast, "Todos los productos han quedado fuera de bodega", "success");

				setEstate("");
				setData({
					estate_id: estate_id,
					balance_id: "",
					user_id: "",
					operator_id: "",
					business_center_id: "",
				});
				setShow(false);
			}
		});
	};

	return (
		<Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} className={classes.main_form}>
			<Modal.Header closeButton>
				<h4 className={classes.modal_title}>Sacar productos</h4>
			</Modal.Header>

			<Modal.Body>
				{isFetching ? (
					<Fetching topMargin={"1em"} />
				) : (
					<Row className={classes.row_form}>
						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Usuario</Form.Label>
								<Select
									value={params.users && params.users.filter((c) => Number(c.value) === Number(data.user_id))}
									placeholder={<div>Seleccione</div>}
									options={params.users ? params.users : []}
									onChange={(value) => setData({ ...data, user_id: value ? value.value : "" })}
									components={{
										NoOptionsMessage,
									}}
									isClearable
								/>
							</Form.Group>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Operador</Form.Label>
								<Select
									value={params.operators && params.operators.filter((c) => Number(c.value) === Number(data.operator_id))}
									placeholder={<div>Seleccione</div>}
									options={params.operators ? params.operators : []}
									onChange={(value) => setData({ ...data, operator_id: value ? value.value : "" })}
									components={{
										NoOptionsMessage,
									}}
									isClearable
								/>
							</Form.Group>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Balanza</Form.Label>
								<Select
									value={params.balances && params.balances.filter((c) => Number(c.value) === Number(data.balance_id))}
									placeholder={<div>Seleccione</div>}
									options={params.balances ? params.balances : []}
									onChange={(value) => setData({ ...data, balance_id: value ? value.value : "" })}
									components={{
										NoOptionsMessage,
									}}
									isClearable
								/>
							</Form.Group>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Centro de Costo</Form.Label>
								<Select
									value={params.business_center && params.business_center.filter((c) => Number(c.value) === Number(data.business_center_id))}
									placeholder={<div>Seleccione</div>}
									options={params.business_center ? params.business_center : []}
									onChange={(value) => setData({ ...data, business_center_id: value ? value.value : "" })}
									components={{
										NoOptionsMessage,
									}}
									isClearable
								/>
							</Form.Group>
						</Col>
					</Row>
				)}
			</Modal.Body>
			<Modal.Footer>
				<Button variant="success" onClick={handleOut} disabled={isFetching}>
					SACAR PRODUCTOS
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default EstateOut;
